import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';

import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';

type Row = {
  id: string;
  name: string;
  c_id: string;
  brand: string;
  model: string;
  year_m: string;
  n_serie: string;
  manufacturer: string;
  date_calibration: string | Date;
  agent: string;
  next_date: string | Date;
  ubication: string;
  priority: string;
  other_things: string;
  vol: string;
  elec: string;
  corr: string;
  electron: string;
  neu: string;
  frec: string;
  hidr: string;
  pot: string;
  capa: string;
  mec: string;
  pe: string;
  info: string;
  alim: string;
  term: string;

  mttos: {
    fail: string;
    date_entry: string | Date;
    procedure: string;
    date_out: string | Date;
    replacement: string;
    observations: string;
  }[];

}

const emptyForm: Row = {
  id: '',
  name: '',
  c_id: '',
  brand: '',
  model: '',
  year_m: '',
  n_serie: '',
  manufacturer: '',
  date_calibration: '',
  agent: '',
  next_date: '',
  ubication: '',
  priority: '',
  other_things: '',
  vol: '',
  elec: '',
  corr: '',
  neu: '',
  frec: '',
  hidr: '',
  pot: '',
  electron: '',
  capa: '',
  mec: '',
  pe: '',
  info: '',
  alim: '',
  term: '',
  mttos: []
}

@Component({
  selector: 'ngx-sgm-formato-catorce',
  templateUrl: './formato-catorce.component.html'
})
export class FormatoCatorceComponent implements OnInit {
  @Input() stationId: string;
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      c_id: {
        title: 'Clave de Identificación',
        filter: true,
      },
      brand: {
        title: 'Marca',
        filter: true,
      },
      date_calibration: {
        title: 'Última Fecha de Calibración',
        filter: true,
        valuePrepareFunction: (date) => moment(date).format('DD-MM-YYYY')
      },
      next_date: {
        title: 'Próxima Fecha de Calibración',
        filter: true,
        valuePrepareFunction: (date) => moment(date).format('DD-MM-YYYY')
      },
    },
    noDataMessage: 'Sin registros',
  };

  constructor(private sgmService: SgmService) {}

  ngOnInit() {
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');
    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
  }

  addMtto () {
    this.row.mttos.push({
      fail: '',
      date_entry: '',
      procedure: '',
      date_out: '',
      replacement: '',
      observations: ''
    })
  }

  removeToArray (index: number, rows: Array<any>) {
    rows.splice(index, 1)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}

